/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFlipbookPagesResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type FlipbookPagesResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type WithPageNumberItemRequestBuilder, WithPageNumberItemRequestBuilderNavigationMetadata, WithPageNumberItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/flipbooks/{flipbookId}/pages
 */
export interface PagesRequestBuilder extends BaseRequestBuilder<PagesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.flipbooks.item.pages.item collection
     * @param pageNumber Unique identifier of the item
     * @returns {WithPageNumberItemRequestBuilder}
     */
     byPageNumber(pageNumber: number) : WithPageNumberItemRequestBuilder;
    /**
     * Upload an image (PNG, JPEG, WebP) or a PDF and add it to an existing flipbook. Every page of a PDF becomes a flipbook page. Pages are added at the end unless AfterPageNumber is given, in which case they are inserted directly after that page (0 inserts at the front). Pages behind the insertion point move down and keep their product tags.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FlipbookPagesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FlipbookPagesResponse | undefined>;
    /**
     * Upload an image (PNG, JPEG, WebP) or a PDF and add it to an existing flipbook. Every page of a PDF becomes a flipbook page. Pages are added at the end unless AfterPageNumber is given, in which case they are inserted directly after that page (0 inserts at the front). Pages behind the insertion point move down and keep their product tags.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PagesRequestBuilderUriTemplate = "{+baseurl}/api/flipbooks/{flipbookId}/pages";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PagesRequestBuilderNavigationMetadata: Record<Exclude<keyof PagesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byPageNumber: {
        requestsMetadata: WithPageNumberItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithPageNumberItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["pageNumber"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PagesRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PagesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFlipbookPagesResponseFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
